import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';


import {Model,SurveyNG,Serializer,ComponentCollection } from "survey-angular";
import { setLicenseKey } from "survey-core";

import {  MenuItem, MessageService, SelectItem } from 'primeng/api';

import { ApiService } from 'src/app/_services/api.service';

import { GlobalService } from 'src/app/_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SurveyCreatorModel } from 'survey-creator-core';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common'

@Component({
  selector: 'app-checkl-edit',
  templateUrl: './checkl-edit.component.html',
  styleUrls: ['./checkl-edit.component.css'],
  providers: [ MessageService],
  encapsulation: ViewEncapsulation.None
})
export class ChecklEditComponent implements OnInit {

  SpeechRecognition:any;
  SpeechGrammarList:any;

  
  
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    setLicenseKey("Y2UyZmM4MzktN2Y3ZS00MGY3LWEwOGYtMzM1YjE3MTkwMzkwOzE9MjAyNC0wOC0wNw==" );
   }
   ufficiList:any[]=[];
   tipologieList:any[]=[];
   argomentiList:any[]=[];
   isLoading:boolean=true;
   cdcList:any[]=[];
   repartiList:any[]=[];
   struttureList:any[]=[];
   vocidispesaList:any[]=[];
   prioritaList:any[]=[
    {
      value:"B",
      text:"Bassa"
    },
    {
      value:"M",
      text:"Media"
    },
    {
      value:"A",
      text:"Alta"
    },
   ];

  survey:any;
  selectedQuestionName:any;
  surveyInstance:any;
 
  creator:any;
  checkl={
    name:'',
    checkl_model_id:0,
    status:'IN COMPILAZIONE'
  };
  
  questionari:SelectItem[] = [];
  surveytitle='';
  action='';  
  jsonData:any;
  id:number;
  surveyCreatorModel: SurveyCreatorModel=new SurveyCreatorModel({});

  recognizing:any;
  recognition:any;
  
  reset() {
    this.recognizing = false;  
  }
  
  

  ngOnInit(): void {
    
    const SpeechRecognition = window['webkitSpeechRecognition'];
    const speechRecognition = new SpeechRecognition();
    this.recognition = new SpeechRecognition();
    this.recognition.continuous = true;
    this.recognizing = false;  
    this.recognition.onend = this.reset;

    this.recognition.onresult = ( (event)=> {
      if(this.selectedQuestionName){
        let txt=this.selectedQuestionName.value;
          if(txt!=''){
            txt+=' ';
          } 
          for (var i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {  
              txt += event.results[i][0].transcript;
            }
          }
        this.selectedQuestionName.value=txt;
      }
   
    });

    _this=this;
    this.action=this.route.snapshot.paramMap.get('action');
    this.id=null;
  
    let argomenti=this.apiService.get('checklists/checkl_getargomentisegnalazioni',{});
    let tipi=this.apiService.get('checklists/checkl_gettipisegnalazioni',{});
    let uffici=this.apiService.get('checklists/checkl_getuffici',{});
    let vocidispesa=this.apiService.get('checklists/checkl_getvocidispesa',{});
    let cdc=this.apiService.get('checklists/checkl_getcdc',{});
    let reparti=this.apiService.get('checklists/checkl_getreparti',{});
    let strutture=this.apiService.get('checklists/checkl_getstrutture',{});

    
    forkJoin([ argomenti,tipi,uffici,vocidispesa,cdc,reparti,strutture]).subscribe(data => {
      this.ufficiList=data[2].Result;
      this.tipologieList=data[1].Result;
      this.argomentiList=data[0].Result;
      this.vocidispesaList=data[3].Result;
      this.cdcList=data[4].Result;
      this.repartiList=data[5].Result;
      this.struttureList=data[6].Result;
      

      if (!this.route.snapshot.paramMap.get('id')) {
          const params: any = {
            userid : this.globalService.loggedUser.id,
            filtroStato:'PUBBLICATO'
          };
      
          this.apiService.get('checklists/listall',params).subscribe(data => {
            const tipiTemp = data.Result;
            for (const tipo of tipiTemp) {
              this.questionari.push({value: tipo.id, label: tipo.name})
            }

        
          });
          this.isLoading=false;
      } else {
        this.id=parseInt(this.route.snapshot.paramMap.get('id'));
       
        let params= {id:this.id,id_user:this.globalService.loggedUser.id};
      
        this.apiService.get('checklists/checkl_edit',params).subscribe(data => {
          for (const g of data.Result) {
            if(g['id']==this.id){
              this.checkl=g;

              this.jsonData = JSON.parse(this.checkl['json']);
       
              if (!Serializer.findClass("rsalist")) {
                ComponentCollection.Instance.add({
                  //Unique component name. It becomes a new question type. Please note, it should be written in lowercase.
                  name: "rsalist",
                  //The text that shows on toolbox
                  title: "Struttura",
                  //The actual question that will do the job
                  questionJSON: {
                      type: "dropdown",
                      placeholder: "Seleziona una struttura...",
                      isRequired: true,
                      choices:this.struttureList
                    },
                  });
              }
              if (!Serializer.findClass("nuovaattivita")) {
                ComponentCollection.Instance.add({
                  name: "nuovaattivita",
                  title: "Azione collegata",
                    elementsJSON: [  
                      {
                        "type": "dropdown",
                        "name": "attivita",
                        "title": "Azione",
                        "choices": [
                        {
                          "value": "nessuna_azione",
                          "text": "Nessuna azione"
                        },
                        {
                          "value": "segnalazione",
                          "text": "Aprire una segnalazione"
                        },
                        {
                          "value": "non_conformita",
                          "text": "Aprire una non conformità"
                          },
                          {
                          "value": "arkiman",
                          "text": "Aprire una manutenzione"
                          },
                        ]
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:this.tipologieList,
                        name: "tipologia",
                        title: "Tipologia",
                        visible: false,
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:this.argomentiList,
                        name: "argomento",
                        title: "Argomento",
                        visible: false,
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:this.ufficiList,
                        name: "uffprovenienza",
                        title: "Ufficio di provenienza",
                        visible: false,
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:this.ufficiList,
                        name: "uffdestinazione",
                        title: "Ufficio di destinazione",
                        visible: false,
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:this.cdcList,
                        name: "centrodicosto",
                        title: "Centro di costo",
                        visible: false,
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:[],
                        name: "reparto",
                        title: "Reparto",
                        visible: false,
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:this.vocidispesaList,
                        name: "vocedispesa",
                        title: "Voce di spesa",
                        visible: false,
                      },
                      {
                        type: "dropdown",
                        isRequired: true,
                        choices:this.prioritaList,
                        name: "priorita",
                        title: "Priorità",
                        visible: false,
                      },
                      {
                        type: "boolean",
                        isRequired: true,
                        name: "daverificare",
                        labelTrue:"Si",
                        title: "Da verificare",
                        visible: false,
                      },
                      {
                        type: "boolean",
                        isRequired: true,
                        name: "problemasicurezza",
                        labelTrue:"Si",
                        defaultValue: "false",
                        title: "Problema sicurezza",
                        visible: false,
                      },
                      {
                        type: "text",
                        name: "oggetto",
                        title: "Oggetto",
                        isRequired: false,
                        visible: false,
                      },
                      {
                        type: "comment",
                        name: "testo",
                        title: "Descrizione",
                        //Use composite. prefix to get the "shippingSameAsBusiness" question inside the contentPanel
                        isRequired: false,
                        visible: false,
                      },
                      {
                        type: "file",
                        name: "allegati",
                        title: "Allega files",
                        storeDataAsText:false,
                        allowMultiple: true,
                        visible: false,
                      }
                  ],
                  onInit() {
                
                  },
                  onCreated(question) {
                    //Hide the title for component/root location
                    question.titleLocation = "hidden";
                    //Change the property value from "off" to "default" to get end-to-end numbering behavior
                    question.contentPanel.showQuestionNumbers = "off";
                    if (_this.jsonData !== undefined && _this.jsonData  !== null) {
                      const attivita = question.contentPanel.getQuestionByName("attivita");
                      const testo = question.contentPanel.getQuestionByName("testo");
                      const argomento = question.contentPanel.getQuestionByName("argomento");
                      const tipologia = question.contentPanel.getQuestionByName("tipologia");
                      const oggetto = question.contentPanel.getQuestionByName("oggetto");
                      const problemasicurezza = question.contentPanel.getQuestionByName("problemasicurezza");
                      const daverificare = question.contentPanel.getQuestionByName("daverificare");
                      const priorita = question.contentPanel.getQuestionByName("priorita");
                      const centrodicosto = question.contentPanel.getQuestionByName("centrodicosto");
                      const vocedispesa = question.contentPanel.getQuestionByName("vocedispesa");
                      const reparto = question.contentPanel.getQuestionByName("reparto");
                      const ufficioprov = question.contentPanel.getQuestionByName("uffprovenienza");
                      const ufficiodest = question.contentPanel.getQuestionByName("uffdestinazione");
                      const allegati = question.contentPanel.getQuestionByName("allegati");
               
                      if((question.name)&&(_this.jsonData[question.name])&&(_this.jsonData[question.name].attivita=='nessuna_azione')){
                        testo.visible = true;
                      }
                      if((question.name)&&(_this.jsonData[question.name])&&(_this.jsonData[question.name].attivita=='segnalazione')){
                        testo.visible = true;
                        argomento.visible = true;
                        tipologia.visible = true;
                        ufficioprov.visible = true;
                        ufficiodest.visible = true;
                        allegati.visible = true;
                      }
                      if((question.name)&&(_this.jsonData[question.name])&&(_this.jsonData[question.name].attivita=='non_conformita')){
                        testo.visible = true;
                        argomento.visible = true;
                        allegati.visible = true;
                        centrodicosto.visible = true;
                        reparto.choices=_this.repartiList;
                        reparto.visible = true;
                      }
                      if((question.name)&&(_this.jsonData[question.name])&&(_this.jsonData[question.name].attivita=='arkiman')){
                        centrodicosto.visible = true;
                        vocedispesa.visible = true;
                        priorita.visible = true;
                        oggetto.visible = true;
                        testo.visible = true;
                        daverificare.visible = true;
                        problemasicurezza.visible = true;
                        allegati.visible = true;
                      }
                  
                    
                    }
                  },
                  onValueChanged(question, name, newValue) {
             
                  if (name === "centrodicosto") {
                    const reparto = question.contentPanel.getQuestionByName("reparto");
                    const centrodicosto = question.contentPanel.getQuestionByName("centrodicosto");
                    reparto.choices=_this.repartiList.filter((x)=>x.cdc==centrodicosto.value);
                  }
                  if (name === "attivita") {
                    const attivita = question.contentPanel.getQuestionByName("attivita");
                    const testo = question.contentPanel.getQuestionByName("testo");
                    const argomento = question.contentPanel.getQuestionByName("argomento");
                    const tipologia = question.contentPanel.getQuestionByName("tipologia");
                    const oggetto = question.contentPanel.getQuestionByName("oggetto");
                    const problemasicurezza = question.contentPanel.getQuestionByName("problemasicurezza");
                    const daverificare = question.contentPanel.getQuestionByName("daverificare");
                    const priorita = question.contentPanel.getQuestionByName("priorita");
                    const centrodicosto = question.contentPanel.getQuestionByName("centrodicosto");
                    const vocedispesa = question.contentPanel.getQuestionByName("vocedispesa");
                    const reparto = question.contentPanel.getQuestionByName("reparto");
                    const ufficioprov = question.contentPanel.getQuestionByName("uffprovenienza");
                    const ufficiodest = question.contentPanel.getQuestionByName("uffdestinazione");
                    const allegati = question.contentPanel.getQuestionByName("allegati");
                    
                    //If shipping address same as business is choosen then
                    
                    if(attivita.value=='nessuna_azione'){
                      testo.visible = true;

                      argomento.visible = false;
                      tipologia.visible = false;
                      ufficioprov.visible = false;
                      ufficiodest.visible = false;
                      allegati.visible = false;

                      centrodicosto.visible = false;
                      reparto.visible = false;
                      vocedispesa.visible = false;
                      priorita.visible = false;
                      oggetto.visible = false; 
                      daverificare.visible = false;
                      problemasicurezza.visible = false;
                    }

                    if(attivita.value=='segnalazione'){
                      testo.visible = true;
                      argomento.visible = true;
                      tipologia.visible = true;
                      ufficioprov.visible = true;
                      ufficiodest.visible = true;
                      allegati.visible = true;

                      centrodicosto.visible = false;
                      reparto.visible = false;
                      vocedispesa.visible = false;
                      priorita.visible = false;
                      oggetto.visible = false; 
                      daverificare.visible = false;
                      problemasicurezza.visible = false;

                    }
                    if(attivita.value=='non_conformita'){
                      testo.visible = true;
                      argomento.visible = true;
                      allegati.visible = true;
                      centrodicosto.visible = true;
                      reparto.visible = true;

                      tipologia.visible = false;
                      ufficioprov.visible = false;
                      ufficiodest.visible = false;
                      vocedispesa.visible = false;
                      priorita.visible = false;
                      oggetto.visible = false;
                      daverificare.visible = false;
                      problemasicurezza.visible = false;
                    }
                    if(attivita.value=='arkiman'){
                      centrodicosto.visible = true;
                      vocedispesa.visible = true;
                      priorita.visible = true;
                      oggetto.visible = true;
                      testo.visible = true;
                      daverificare.visible = true;
                      problemasicurezza.visible = true;
                      allegati.visible = true; 
                      argomento.visible = false;
                      tipologia.visible = false;
                      ufficioprov.visible = false;
                      ufficiodest.visible = false;
                      reparto.visible = false;
                      
                    }

                  }
                  },
                });
              
              }


              if(this.checkl['json_modello']){
                let modello=JSON.parse(this.checkl['json_modello']);
      
                modello.pages[0].elements.splice(0, 0,{
                type: "rsalist",
                name: "struttura",
                visible:true
              });

                modello.pages.forEach((p)=>{
                  let ele=[];
      
                  p.elements.forEach((e)=>{
                    let mostraattivita=false;
                    let readonly=false;
                    let trovato=false;
                    if (this.jsonData !== undefined && this.jsonData  !== null) {

                      //matrixdynamic
                      if(e.type=='matrixdynamic'){
                        trovato=true;
                        if (this.jsonData[e.name] !== undefined && this.jsonData[e.name] !== null) {
                          let isfirst=true;
                          this.jsonData[e.name].forEach((x,ind)=>{
                            for (const key in x){
                              if(x[key].toUpperCase()=='NO'){
                                if(this.jsonData[e.name+'_attivita_id'+ind]){
                                  readonly=true;
                                }
                                e.readOnly=readonly;
                                if(isfirst){
                                  isfirst=false;
                                  ele.push(e);
                                }
                                
                                ele.push(  {
                                  type: "nuovaattivita",
                                  name: e.name+"_attivita"+ind,
                                  visible:true,
                                  readOnly:readonly
                                });
                              } else {
                                 ele.push(e);
                              }
                            }
                          })
                        } else {
                          ele.push(e);
                        }
                      }
                      // radiogroup
                      if(e.type=='radiogroup'){
                        trovato=true;
                        if((this.jsonData[e.name])&&(this.jsonData[e.name].toString().indexOf('_')<0)&&(this.jsonData[e.name].toString().toUpperCase()=='NO')){
                          mostraattivita=true;
                          if(this.jsonData[e.name+'_attivita_id']){
                            readonly=true;
                          }
                        }
                        if((this.jsonData[e.name+"_attivita"])&&(this.jsonData[e.name+"_attivita"]=='nessuna_azione')){
                          mostraattivita=true;
                        }
                        e.readOnly=readonly;
                        ele.push(e);
                        if(mostraattivita){
                          ele.push(  {
                            type: "nuovaattivita",
                            name: e.name+"_attivita",
                            visible:mostraattivita,
                            readOnly:readonly
                          });
                         
                        }
                      }  
                      //matrix
                      if(e.type=='matrix'){
                        trovato=true;
                        if (this.jsonData[e.name] !== undefined && this.jsonData[e.name] !== null) {
                          for (const key in this.jsonData[e.name]){
                             if(this.jsonData[e.name][key].toUpperCase()=='NO'){
                              if(this.jsonData[e.name+'_attivita_id'+key]){
                                readonly=true;
                              }
                              e.readOnly=readonly;
                              ele.push(e);
                              ele.push(  {
                                type: "nuovaattivita",
                                name: e.name+"_attivita"+key,
                                visible:true,
                                readOnly:readonly
                              });
                            }
                          }
                        }else {
                          ele.push(e);
                        }
                      }
                      if(!trovato){
                        ele.push(e);
                      }
                    } else {
                      ele.push(e);
                    }

                  });
                  p.elements=ele;
       
                });
             
                

                this.survey = new Model(modello);
                if(this.checkl['status']=='COMPILATO'){
                  this.survey.mode = "display";
                }
              
            
                this.survey.data =  JSON.parse(this.checkl['json']);
// VALUE CHANGED
                this.survey.onValueChanged.add((sender, options) => {
            
                 
                  if(options.name.indexOf('_')>0){
                    return;
                  } 
                  const question = this.survey.getQuestionByName(options.name);
                  // MATRIX
       
                  if((question)&&(question.jsonObj)&&((question as any).jsonObj.type=='matrix')){
                    for (const key in options.question.value){
                      let question_related = this.survey.getQuestionByName(options.name+'_attivita'+key);
                      const value = options.question.value[key];
                      if((!question_related)&&(value.toUpperCase()=='NO')){
                        this.survey.pages.forEach((p,ind)=>{
                          let cc=0;
                          p.elements.forEach((e)=>{
                            if(e.name==options.name){
                                var newQuestion = this.survey.pages[ind].addNewQuestion("nuovaattivita", e.name+"_attivita"+key, cc+1);
                                newQuestion.visible = true;
                            }
                            cc++;
                          });
                        });
                      } else {
                        if(question_related){
                          if (value.toString().toUpperCase()=='NO') {
                            question_related.visible=true;
                          } else {
                            question_related.visible=false;
                          }
                        }
                    
                      }
                    }
                  }
                  // RADIOGROUP
                  if((question)&&(question.jsonObj)&&((question as any).jsonObj.type=='radiogroup')){
                    let question_related = this.survey.getQuestionByName(options.name+'_attivita');
                    if((!question_related)&&(options.value.toString().toUpperCase()=='NO')){
                      this.survey.pages.forEach((p,ind)=>{
                        let cc=0;
                        p.elements.forEach((e)=>{
                          if(e.name==options.name){
                              var newQuestion = this.survey.pages[ind].addNewQuestion("nuovaattivita", e.name+"_attivita", cc+1);
                              newQuestion.visible = true;
                          }
                          cc++;
                        });
                      });
                    } else{
                      if(question_related){
                        if (options.value.toString().toUpperCase()=='NO') {
                          question_related.visible=true;
                        } else {
                          question_related.visible=false;
                        }
                      }
                    
                    }
                  }

                });

                this.survey.onComplete.add((sender, options) => {
                  this.checkl['json']=JSON.stringify(sender.data, null, 3);
                  this.checkl['status']='COMPILATO';
                  this.apiService.updateCheckl(this.checkl).subscribe(data => {
                    this.addSingle('success', 'Successo', 'Questionario salvato');
                    setTimeout(() => {
                      this.location.back();
                    }, 1500);
                  });          
                });

                const questions = this.survey.getAllQuestions();
                for (const question of questions) {
                  const type = question.getType();
                  if (type === "file") {
                    question.storeDataAsText = false;
                  }
                }
                this.survey.onUploadFiles.add((_, options) => {
                  const formData = new FormData();
                  options.files.forEach(file => {
                      formData.append(file.name, file);
                  });
                  fetch( environment.QUESTIONARI_URL+'upload.php', {
                      method: "POST",
                      body: formData
                  })
                  .then(response => response.json())
                  .then(data => {

                      options.callback("success", options.files.map((file,ind) => {
                          return {
                              file: file,
                              content: environment.QUESTIONARI_URL+'/files/' + data[ind].nameserver
                          };
                      }));
                  })
                  .catch(error => {
                      console.error("Error: ", error);
                  });
                });
// MATRIC VALUECHANGED           
                this.survey.onMatrixCellValueChanged.add((survey, options) => {  
                  survey.pages.forEach((p,ind)=>{
                    let cc=0;
                   
                    p.elements.forEach((e)=>{
                      if(e.name==options.question.jsonObj.name){
                     
                        if((options.cellQuestion.jsonObj.cellType=="radiogroup")&&(options.value.toUpperCase()=='NO')){
                          let isPresent=false;
                      
                            survey.pages.forEach((p,ind)=>{
                              p.elements.forEach((e)=>{
                                if(e.name== e.name+"_attivita"+options.row.index){
                                  isPresent=true;
                                  e.visible=true;
                                }
                              });
                            });
                       
                            if(!isPresent){
                              var newQuestion = this.survey.pages[ind].addNewQuestion("nuovaattivita", e.name+"_attivita"+options.row.index, cc+1);
                              newQuestion.visible = true;
                            }
                        }
                      }
                      cc++;
                    });
                  });
                });

                this.survey.onFocusInQuestion.add((sender, options) => {
        
                  const activeElement = document.activeElement;

                  if (activeElement instanceof HTMLElement ){
                
                    if((activeElement.tagName.toLowerCase()=='input')||(activeElement.tagName.toLowerCase()=='textarea')) {
                      this.selectedQuestionName=activeElement;
                    }
                  } else {
                    this.selectedQuestionName= null;
                    this.surveyInstance=null;
                  }

                });
                this.isLoading=false;
                
                SurveyNG.render("surveyCreator", { model: this.survey });
              }
            }
          }
        });
    
    
    
      }
          
    });
      
  }
  
 

  public save() {
    if(this.action=='new'){
      if (this.checkl['checkl_model_id']==0) {
        this.addSingle('error', 'Error', 'Selezionare un questionario');
        return;
      }
      this.checkl['name']=this.questionari.filter((X)=>X.value==this.checkl['checkl_model_id'])[0].label;
      this.checkl['name']+='-'+this.globalService.loggedUser.username;
      this.apiService.updateCheckl(this.checkl).subscribe(data => {
        this.addSingle('success', 'Successo', 'Questionario salvato');
        this.router.navigateByUrl('/dashboard/checklists/checkl-edit/update/'+data.Result.id);
      });

    } else {
      if(this.id){
        this.checkl['id']=this.id;
        this.checkl['json']=JSON.stringify(this.survey.data, null, 3);
        this.apiService.updateCheckl(this.checkl).subscribe(data => {
          this.addSingle('success', 'Successo', 'Questionario salvato');
          this.router.navigateByUrl('/dashboard/checklists/checkl');
        });
      }
    }

  }
 

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  userCanRollBack(){
   return  ((this.globalService.loggedUser.id==156)||(this.globalService.loggedUser.id==157)||(this.globalService.loggedUser.id==5952)||(this.globalService.loggedUser.id==112));
  }
  rollBack(){
    let params={id:this.route.snapshot.paramMap.get('id')};
    this.apiService.get('checklists/roolback',params).subscribe(data => {
      this.addSingle('success', 'Successo', 'Questionario riaperto');
      setTimeout(() => {
        this.location.back();
      }, 1500);
    });
  }

  printPdf(){
    
    let params={id:this.route.snapshot.paramMap.get('id')};
    this.apiService.get('checklists/checkl_listallresults',params).subscribe((data:any) => {
      let paramsUser={id:data.Result.userid};
      this.apiService.get('users/listall',paramsUser).subscribe((dataUser:any) => {
      
        this.globalService.print_checklist(data.Result,dataUser);
      });
     
    });

  }

  registra(){
    this.reset();
    this.recognition.start();
    this.recognizing = true;
  }
  registraStop(){
    this.recognition.stop();
    this.reset();
  }

}

var _this;